import React from 'react';
import PropTypes from 'prop-types';
import DmarcChartSectionContainer from '../../containers/domain-portfolio/dmarc-chart-section-container';

const DomainPortfolioReport = ( { onInitialLoad } ) => {
    return (
        <DmarcChartSectionContainer onInitialLoad={onInitialLoad}/>
    );
};

DomainPortfolioReport.propTypes = {
    onInitialLoad: PropTypes.func.isRequired,
};

export default DomainPortfolioReport;
